import { View, StyleSheet, TouchableOpacity, ActivityIndicator, Platform } from 'react-native';
import { Audio } from 'expo-av';
import * as FileSystem from "expo-file-system";
import { COLORS } from '../constants';
import PlayIcon from '../assets/images/play.svg';
import PauseIcon from '../assets/images/pause.svg';
import PrevIcon from '../assets/images/prev.svg';
import NextIcon from '../assets/images/next.svg';
import { useEffect, useState } from 'react';
import { useGlobalContext } from '../context/GlobalContext';
import { Icon } from '../lib/Icon';

export const getNameAudio = (hymnId: number) => {
  return `${String(hymnId).padStart(4, '0')}.mp3`;
}

export const getUriAudio = (hymnId: number) => {
  return `https://hymns.nyc3.cdn.digitaloceanspaces.com/youth/${getNameAudio(hymnId)}`;
}

function Player () {
  const [loading, setLoading] = useState<boolean>(false);
  const [play, setPlay] = useState<boolean>(false);
  const [player, setPlayer] = useState<Audio.Sound>();
  const {
    setCurrentTimer,
    setTotalTimer,
    hymnId,
    setHymnId,
    startDownload
  } = useGlobalContext()

  const stopAndClean = () => {
    setPlayer(undefined);
    setPlay(false);
    setLoading(false);
  }

  const handlePlay = async () => {
    if (player) {
      await player.playAsync();
    } else {
      try {
        setLoading(true);
        let uri = getUriAudio(hymnId);

        if (Platform.OS !== 'web') {
          const fileUri = `${FileSystem.documentDirectory}${getNameAudio(hymnId)}`;
          const fileInfo = await FileSystem.getInfoAsync(fileUri);
          if (fileInfo?.exists) {
            uri = fileUri;
          } 
          console.log('URI', uri, 'TYPE: ', fileInfo?.exists ? 'DESCARGA' : 'URL');
        }
        const { sound, status } = await Audio.Sound.createAsync(
          { uri },
          { shouldPlay: true },
          (status) => {
            if (status.isLoaded && setCurrentTimer) {
              setCurrentTimer(status.positionMillis || 0)
              if (status.durationMillis === status.positionMillis) {
                stopAndClean();
              }
            }
          }
        );
        setPlayer(sound);
        await sound.playAsync();
        setLoading(false);
        if (status.isLoaded && setTotalTimer) {
          setTotalTimer(status.durationMillis || 0)
        }
      } catch (error) {
        console.log('ERROR PLAY', error);
        return stopAndClean();
      }
    }
    setPlay(true);
  }
  
  const handlePause = async () => {
    console.log('Pause!')
    await player?.pauseAsync();
    setPlay(false);
  }

  useEffect(() => {
    stopAndClean();
  }, [hymnId, startDownload]);

  useEffect(() => {
    return player
      ? () => {
          console.log('Unloading Sound');
          player.unloadAsync()
          .then(() => {
            setPlayer(undefined);
            setPlay(false);
            console.log('Stop sound');
          });
        }
      : undefined;
  }, [player]);

  const prev = () => {
    stopAndClean();
    setHymnId(hymnId - 1)
  }

  const next = () => {
    stopAndClean();
    setHymnId(hymnId + 1)
  }

  return (
    <View style={styles.container}>
      <TouchableOpacity
        disabled={hymnId === 1}
        style={styles.play}
        onPress={prev}>
        <Icon><PrevIcon /></Icon>
      </TouchableOpacity>
      {!play && !loading && <TouchableOpacity
        style={styles.play}
        onPress={handlePlay}>
        <Icon><PlayIcon /></Icon>
      </TouchableOpacity>}
      {loading && <View style={styles.play}>
        <ActivityIndicator color={COLORS.borderLight} size="large" />
      </View>}
      {play && <TouchableOpacity
        style={styles.play}
        onPress={handlePause}>
        <Icon><PauseIcon /></Icon>
      </TouchableOpacity>}
      <TouchableOpacity
        disabled={hymnId === 317}
        style={styles.play}
        onPress={next}>
        <Icon><NextIcon /></Icon>
      </TouchableOpacity>
    </View>
  )
}

const width = 172;
const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 15,
    borderWidth: 1,
    borderColor: COLORS.line,
    borderRadius: 28,
    width,
    left: '50%',
    marginLeft: - width / 2,
    height: 52,
    backgroundColor: COLORS.white,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'center'
  },
  play: {
    marginHorizontal: 1,
    borderRadius: 50,
    width: 42,
    height: 42,
    justifyContent: 'center',
    alignItems: 'center',
  }
});

export default Player;
